import React from 'react';
import PropTypes from 'prop-types';
import { LocalForm, Control } from 'react-redux-form';
import {
  Col,
  ControlLabel,
} from 'react-bootstrap';

import DatePicker from 'react-datepicker';
import Moment from 'moment';

const AcquisitionTelemetryDateComponent = ({ onChange }) => (
  <div>
    <LocalForm
      id="date-selector-form"
      onSubmit={onChange}
      onChange={onChange}
    >
      <Col md={2}>
        <ControlLabel> Pick a Date </ControlLabel>
        <Control.custom
          id="date-input"
          model=".date"
          component={DatePicker}
          className="form-control"
          maxDate={Moment()}
          mapProps= {({ modelValue, onChange }) => {
            return {
              dateFormat: 'YYYY-MM-DD',
              selected: Moment(modelValue),
              onChange: onChange
            };
          }}
        />
      </Col>
    </LocalForm>
  </div>
);

AcquisitionTelemetryDateComponent.propTypes = { onChange: PropTypes.func.isRequired };

export default AcquisitionTelemetryDateComponent;


// WEBPACK FOOTER //
// src/Components/AcquisitionTelemetryDateComponent.jsx